import { notes } from "@phoenixreisen/mithrils/src/notification";
import { logError } from "../../../shared/functions/misc";
import Loader from "@phoenixreisen/mithrils/src/loader";
import { getSampleBooking } from "../shared/functions";
import { Context } from "../shared/context";
import Config from "../../../config";
import striptags from "striptags";
import m from "mithril";
const RouteLink = m.route.Link;
function loadRechNr(state) {
    state.loading = true;
    getSampleBooking()
        .then((result) => {
        const rechnr = result["rech-nr"];
        const name = result["nachname"];
        m.route.set(`/kunde/${rechnr}/${name}`);
    })
        .catch((error) => {
        notes.add({
            status: "error",
            text: error["userfriendly-message"] ||
                `Huch, beim Generieren der Musterbuchung ist ein Fehler
            aufgetreten. Bitte versuchen Sie es später erneut.`,
        });
        logError(error);
    })
        .finally(() => {
        state.loading = false;
        m.redraw();
    });
}
export const View = {
    oninit({ state }) {
        state.loading = false;
    },
    view({ state }) {
        const { html } = Config;
        const { loading } = state;
        const { webtexte: wt } = Context;
        try {
            if (!wt) {
                return m(Loader, null);
            }
            return (m("section", { class: "gettoknow gettoknow-text" },
                m("article", { class: "gettoknow__img-headline" },
                    m("div", { class: "wrapper wrapper--large" },
                        m("h1", null, wt["login__mp__kennenlernen__headline"] ||
                            "Mein Phoenix kennenlernen"))),
                m("article", { class: "whitegray mb3 gettoknow__btns" },
                    m("div", { class: "wrapper wrapper--large" },
                        m("div", { class: "row row--2er" },
                            m("div", { class: "tl" },
                                m(RouteLink, { href: "/", id: "gettoknow-back-1", title: "Zur\u00FCck auf Anfang", class: "btn btn--link mr2" },
                                    m("i", { class: "fas fa-arrow-left mr1" }),
                                    " Zur\u00FCck")),
                            m("div", { class: "tr" },
                                m("button", { type: "button", disabled: loading, id: "gettoknow-btn-1", name: "gettoknow-btn-1", class: "btn btn--primary", onclick: () => loadRechNr(state) },
                                    "Ausprobieren",
                                    " ",
                                    !loading ? (m("i", { class: "fas fa-arrow-right ml1" })) : (m("i", { class: "fas fa-spinner fa-spin ml1" }))))))),
                m("article", { class: "wrapper wrapper--large relative gettoknow__content" }, m.trust(striptags(wt["login__mp__kennenlernen__text"], html.allowed))),
                m("article", { class: "wrapper wrapper--large gettoknow__btns" },
                    m("div", { class: "row row--2er" },
                        m("div", { class: "tl" },
                            m(RouteLink, { href: "/", id: "gettoknow-back-2", title: "Zur\u00FCck auf Anfang", class: "btn btn--link mr2" },
                                m("i", { class: "fas fa-arrow-left mr1" }),
                                " Zur\u00FCck")),
                        m("div", { class: "tr" },
                            m("button", { type: "button", disabled: loading, id: "gettoknow-btn-2", name: "gettoknow-btn-2", class: "btn btn--primary", onclick: () => loadRechNr(state) },
                                "Ausprobieren",
                                " ",
                                !loading ? (m("i", { class: "fas fa-arrow-right ml1" })) : (m("i", { class: "fas fa-spinner fa-spin ml1" }))))))));
        }
        catch (e) {
            logError(e);
            location.href = Config.urls.FE_ERROR;
        }
    },
};
export default View;
